import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const WeeklyBarChart = ({
  data,
  disabled = false,
  message = "No data available",
}: {
  data: any;
  disabled?: boolean;
  message?: string;
}) => {
  function formatDate(dateString: string): string {
    const date = new Date(dateString);
    const options: any = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  function convertToFormattedArray(data: any): any {
    return data.map((item: any) => ({
      week: `${formatDate(item.startDate)} - ${formatDate(item.endDate)}`,
      count: item.count,
    }));
  }

  if (disabled || !data || data.length === 0) {
    return (
      <div
        style={{
          width: "100%",
          height: 300,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {message}
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={convertToFormattedArray(data)}>
          <XAxis dataKey="week" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeeklyBarChart;
